module.exports = __webpack_public_path__ + "img/phone_k72.43df6216.png";